import {TemplateRef} from "@angular/core";

export class TemplateAndValue {
  constructor(public template: TemplateRef<any>,
              public value: any) {
  }
}
